import { Action } from 'redux';

import { LINK_REQUEST, LINK_RESPONSE, LINK_ERROR } from '../../actions/Flight/orders';

export interface AwadOrdersState {
    orderLink: string | null;
    orderLoading: boolean;
    orderError: string | null;
}

const initialState: AwadOrdersState = {
    orderLink: null,
    orderLoading: false,
    orderError: null
};

export function awadOrders(state: AwadOrdersState = initialState, action: Action) {
    switch (action.type) {
        case LINK_REQUEST: {
            return {
                ...state,
                orderLoading: true,
                orderError: initialState.orderError
            };
        }
        case LINK_RESPONSE: {
            const response = (action as any).response;
            if (response.result) {
                return {
                    ...state,
                    orderLoading: false,
                    orderLink: response.result.url
                };
            } else {
                return {
                    ...state,
                    orderLoading: false,
                    orderError: 'No result node in response JSON'
                };
            }
        }
        case LINK_ERROR: {
            const err = (action as any).error;
            return {
                ...state,
                orderLoading: false,
                orderError: err
            };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/Flight/awadOrders.ts